import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const TooltipRootContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") TooltipRootContext.displayName = "TooltipRootContext";
function useTooltipRootContext(optional) {
  const context = React.useContext(TooltipRootContext);
  if (context === void 0 && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : formatErrorMessage(72));
  }
  return context;
}
export {
  TooltipRootContext,
  useTooltipRootContext
};
//# sourceMappingURL=TooltipRootContext.js.map
